import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

interface UseRegressMaintenanceDirectiveExecutionEntryProps {
  directiveEntryId: string | undefined;
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useRegressMaintenanceDirectiveExecutionEntry = ({
  directiveEntryId,
  options,
}: UseRegressMaintenanceDirectiveExecutionEntryProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['regressMaintenanceDirectiveExecutionEntry'],
    mutationFn: () => {
      return privateAxios.put(`/maintenance/directive/execution_entries/${directiveEntryId}/regress`);
    },
    ...options
  });
}
